import { useCallback, useEffect, useMemo, useState } from 'react'

import { IFilter } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import { getValuesFromFilter } from 'partner360/components/simplePartnerTable/filterArea/helpers/getValuesFromFilter'

import { IJbpPartners } from '../../models'
import { getFormFilters } from '../helpers/getFormFilters'

export const useFilterArea = (crud: Crud<IJbpPartners, string | number>) => {
  const [market, setMarket] = useState('')
  const [country, setCountry] = useState('')
  const [partnerId, setPartnerId] = useState('')
  const [partnerName, setPartnerName] = useState('')
  const [filterApplied, setFilterApplied] = useState(false)
  const [notResetCountry, setNotResetCountry] = useState(false)

  const initialFilters = (crud.getFilter()?.filters || []) as IFilter[]
  const onFilter = useCallback(() => {
    const filter = getFormFilters({ country, market, partnerId, partnerName, initialFilters })
    crud.setFilter(filter)
    crud.removeQueries(true)
    setFilterApplied(true)
  }, [country, market, partnerId, partnerName, initialFilters])

  const onResetFilter = useCallback(() => {
    const filter = getFormFilters({
      country: '',
      market: '',
      partnerId: '',
      partnerName: '',
      initialFilters,
    })
    crud.setFilter(filter)
    crud.removeQueries(true)
    setFilterApplied(false)
    setCountry('')
    setMarket('')
    setPartnerId('')
    setPartnerName('')
  }, [country, market, partnerId, partnerName, initialFilters])

  useMemo(() => {
    if (!notResetCountry) {
      setCountry('')
    }

    setNotResetCountry(false)
  }, [market])

  useEffect(() => {
    const filter = crud.getFilter()
    if (filter && filter.filters.length > 0) {
      const filters = filter.filters as IFilter[]
      const {
        countryFilterValue,
        marketFilterValue,
        partnerIdFilterValue,
        partnerNameFilterValue,
      } = getValuesFromFilter(filters)
      setCountry(countryFilterValue)
      setMarket(marketFilterValue)
      setPartnerId(partnerIdFilterValue)
      setPartnerName(partnerNameFilterValue)
      setFilterApplied(true)
      setNotResetCountry(true)
    }
  }, [])

  return {
    onFilter,
    filterApplied,
    onResetFilter,
    market,
    country,
    setMarket,
    setCountry,
    partnerId,
    setPartnerId,
    partnerName,
    setPartnerName,
  }
}
